import { render, staticRenderFns } from "./cover-field-horizontal.vue?vue&type=template&id=294de97b&scoped=true"
import script from "./cover-field-horizontal.vue?vue&type=script&lang=js"
export * from "./cover-field-horizontal.vue?vue&type=script&lang=js"
import style0 from "./cover-field-horizontal.vue?vue&type=style&index=0&id=294de97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294de97b",
  null
  
)

export default component.exports